import { memo } from 'react';
import { NodeProps } from '@xyflow/react';
import { getObjectTypeColor } from '../helpers/getObjectTypeColor';
import { NodeEntityTypes } from '../canvas-types';

import { Button, __SWEEP_DESIGN_TYPOGRAPHY_STYLES___ } from '@sweep-io/sweep-design';

import { SweepNodeHandles } from './SweepNodeHandles';
import { NodeComponent } from './components/SweepNodeComponent';
import { RfNodeGhostNode } from '../canvas-types/nodeTypesData';

const GhostNode = ({
  id,
  data: { objectType, onNodeClick, parentId, name },
}: NodeProps<RfNodeGhostNode>) => {
  const { light: backgroundColor, connection: handleColor } = getObjectTypeColor(
    objectType as ObjectTypeValues,
  );

  return (
    <SweepNodeHandles>
      <NodeComponent
        sx={{
          background: backgroundColor,
          borderColor: handleColor,
          display: 'flex',
          alignItems: 'center',
          width: 'fit-content',

          padding: '0 12px',
          '& > .MuiButton-root': {
            ...__SWEEP_DESIGN_TYPOGRAPHY_STYLES___.h4,
          },
        }}
      >
        <Button
          variant="flat"
          endIconName="ArrowRight"
          onClick={(e) => {
            onNodeClick?.({
              event: e,
              id,
              parentId,
              entity: {
                type: NodeEntityTypes.GhostStepButton,
              },
            });
          }}
        >
          {name}
        </Button>
      </NodeComponent>
    </SweepNodeHandles>
  );
};

const _memoGhostNode = memo(GhostNode);

export { _memoGhostNode as GhostNode };
